import React from 'react';
import { MDBCol, MDBContainer, MDBIcon, MDBRow } from "mdbreact";
import TableComponent from '../../components/SharedComponents/Table';
import SelectField from '../../components/SharedComponents/SelectField/SelectField';
import BasicButton from '../../components/SharedComponents/BasicButton/BasicButton';
import InlineButtonField from '../../components/SharedComponents/InlineButtonField/InlineButtonField';
import {
    updateTableSortConfigObject,
    tableSortList,
} from "../../Common/TableHelper";
import messages from '../../Common/Messages.json';
import sizeLimits from '../../Common/SizeLimits.json';
import * as Constants from "../../../constants/constants";
import CasterService from "../../../services/service";
import { withUserContext } from '../../../contexts/UserContext';
import { lookupConfig,statusFilterOptions } from './Config';
import './LookupValues.scss';
import BasicTextField from '../SharedComponents/BasicTextField/BasicTextField';

class LookupValues extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedType: "",
            lookupType: [],
            tableData: [],
            showContent: false,
            inlineButtonField: "",
            setIndex: 0,
            sortCount: 0,
            sortBy: "Value",
            isSortByAsc: true,
            config: lookupConfig,
            renderList:[],
            filteredList: [],
            filterText: '',
            selectedStatus: "All",
            warningMessage: false
        }
    }

    componentDidMount() {
        this.getLookupType()
    }

    getLookupType = () => {
        CasterService.getData(Constants.CasterServiceBaseUrl + `/casterFeatureSearch?objectType=LOOKUP_DATA`)
            .then((response) => {
                if (response?.data?.error) {
                    console.log('error from search', response?.data?.error)
                } else {
                    let formattedList = response?.data
                    this.setState({ lookupType: formattedList })
                }
            },
                (err) => {
                    console.log("Post Lookup details error: " + err);
                });
    }

    fetchDetails = (val) => {
        this.setState({ selectedType: val, isFetchingLookupValues: true, filterText: '',selectedStatus: "All"});
        CasterService.getData(Constants.CasterServiceBaseUrl + '/casterFeatureLookup?objectType=' + val, this.props.userContext?.active_tenant?.tenant_id)
            .then(response => {
                let formattedList = response.data?.map(item => ({
                    value: item.lookup_data_id, label: item.lookup_value, check: item.is_active === 1 ? true : false,
                    lookup_key: item.lookup_key,
                    lookup_value: item.lookup_value,
                    lookup_code: item.lookup_code,
                    is_active: item.is_active
                }));
                this.setState({
                    tableData: formattedList,
                    showContent: true,
                    renderList: formattedList,
                    filteredList: formattedList,
                    isFetchingLookupValues: false
                });
            },
                (err) => {
                    console.log("Error in fetching Data:", err)
                    this.setState({ isFetchingLookupValues: false })
                })
    }

    editList = (item) => {
        if (this.state.setIndex === 0) {
            if (this.state.inlineButtonField && this.state.inlineButtonField.length <= sizeLimits.nameCharacterLimit) {
                let details = JSON.parse(JSON.stringify([...this.state.tableData]))
                const isDuplicate = details.some(
                    (entry) => entry.lookup_value.toLowerCase() === this.state.inlineButtonField.toLowerCase()
                  );                  
                if (isDuplicate) {
                    this.setState({ warningMessage: true });
                    return;
                }
                let dataItem = {
                    check: true,
                    value: null,
                    lookup_key: this.state.selectedType,
                    lookup_value: this.state.inlineButtonField,
                    lookup_code: null,
                }
                this.setState({ inlineButtonField: "", isFetchingLookupValues: true, warningMessage:false }, () => {
                    this.handleSubmit(false, dataItem)
                })
            }
        }
    }

    handleSubmit = (setIndex = false,dataItem) => {
        let postData = {
            is_active: dataItem.check ? 1 : 0,
            lookup_data_id: dataItem.value,
            lookup_key: dataItem.lookup_key,
            lookup_value: dataItem.lookup_value,
            lookup_code: dataItem.lookup_code,
        }

        CasterService.postDataParams(Constants.CasterServiceBaseUrl + '/featureLookupData',
            postData, this.props.userContext?.active_tenant?.tenant_id)
            .then(response => {
                this.fetchDetails(this.state.selectedType)
            },
                (err) => {
                    console.log("Error in fetching Details:", err)
                })
    }


    arrayCheckUncheck = (event, dataItem) => {
        let details = JSON.parse(JSON.stringify([...this.state.tableData]))
        details?.map(item => {
            if (item.value === dataItem.value) {
                item.check = dataItem.check;
            }
        });
        this.setState({ tableData: details, formEdited: true }, () => {
            this.handleSubmit(false, dataItem);
        });
    }


    editData = (dataItem, node) => {
        console.log("check the data item on edit", dataItem)
        this.setState({ inlineButtonField: dataItem.label, setIndex: dataItem.value })
    }

    handleTableColumnClick = (column) => {
        if (column === this.state.sortBy) {
            this.setState({ sortCount: this.state.sortCount + 1 }, () => {
                this.handleTableSort(column);
            })
        }
        else this.setState({ sortCount: 0 }, () => {
            this.handleTableSort(column);
        })
    }

    getSortNode = (col) => {
        switch (col) {
            case "Value": return "label";
            case "Active": return "check";
            default: return null;
        }
    }

    handleTableSort = (colName) => {
        const isSortByAsc = this.state.sortCount % 2 === 0;
        const sortKey = this.getSortNode(colName);
    
        if (!sortKey) return;
    
        const sortedList = tableSortList("Name", sortKey, this.state.tableData, isSortByAsc);
    
        this.setState({
            isSortByAsc,
            sortBy: colName,
            config: updateTableSortConfigObject(this.state.config, isSortByAsc, this.state.sortBy, colName),
            renderList: sortedList,
            filteredList: this.state.filterText
                ? this.filterListBySearchAndStatus(sortedList, this.state.filterText, this.state.selectedStatus)
                : this.filterListBySearchAndStatus(sortedList, '', this.state.selectedStatus)
        });
    };
     

    saveItem = (index, value) => {
        this.setState({ setIndex: 0, inlineButtonField: "", isFetchingLookupValues: true })
        let editedItem = this.state.renderList.find(item => item.value == index)
        editedItem.lookup_value = value
        editedItem.label = value
        this.handleSubmit(false, editedItem);
    }

    handleFilterChange = (e) => {
        const input = e.target.value;
        const value = input.toLowerCase();
        const filtered = this.filterListBySearchAndStatus(this.state.renderList, value, this.state.selectedStatus);
    
        this.setState({
            filterText: input,
            filteredList: filtered
        });
    };

    handleStatusChange = (e) => {
        const selected = e.target.value;
        const filtered = this.filterListBySearchAndStatus(this.state.renderList, this.state.filterText, selected);
        this.setState({
            selectedStatus: selected,
            filteredList: filtered
        });
    };

    filterListBySearchAndStatus = (list, text, status) => {
        return list.filter(item => {
            const matchesText = item.lookup_value?.toLowerCase().includes(text);
            const matchesStatus = 
                status === "All" ? true :
                status === "Active" ? item.check === true :
                status === "Inactive" ? item.check === false : true;
            return matchesText && matchesStatus;
        });
    }
            
    clearFilter = () => {
        const { selectedStatus, renderList } = this.state;
        const filtered = this.filterListBySearchAndStatus(renderList, '', selectedStatus);
        this.setState({ filterText: '', filteredList: filtered });
      }   
    
    render() {
        return (
            <MDBContainer className="ManageLookupContainer">
                <MDBRow>
                    <div className="pt3 helper-text">
                        <span> Select a system field to update their value list.</span>
                    </div>
                </MDBRow>
                <MDBRow className="pt2">
                    <MDBCol md={12}>
                        <div>
                            <SelectField
                                label="Selected Field"
                                placeHolderText={"- Select -"}
                                value={this.state.selectedType}
                                options={this.state.lookupType}
                                onChange={(e) => { this.fetchDetails(e.target.value) }}
                            />
                        </div>
                    </MDBCol>
                </MDBRow>
                    <MDBRow className="mt-4 pt-1 bg-white justify-content-between align-items-end">
                    <MDBCol md={7} className='ps-1'>
                    <div className="search-input-wrapper">
                        <BasicTextField
                            id="lookup-value"
                            placeholder="Search lookup Value"
                            value={this.state.filterText}
                            onChange={this.handleFilterChange}
                        />
                        {this.state.filterText?.length > 0 && (
                        <MDBIcon
                            icon="times"
                            onClick={() => this.clearFilter()}
                            className="clear-icon"
                        />
                        )}
                    </div>
                    </MDBCol>
                    <MDBCol md={3}>
                    <div>
                        <SelectField
                            placeHolderText="- Select Status -"
                            value={this.state.selectedStatus}
                            options={statusFilterOptions}
                            onChange={this.handleStatusChange}
                        />
                    </div>
                    </MDBCol>
                    </MDBRow>            
                <MDBRow>
                    <MDBCol className={`${this.state.renderList?.find(item => item.value === this.state.setIndex) ? 'highlightSelectedValue' : ''} lookup-table`}>
                        <TableComponent
                            className={"lookupValue"}
                            stickyHeader={true}
                            tableMode={"white"}
                            list={this.state.filteredList || []}
                            config={lookupConfig}
                            isLoading={this.state.isFetchingLookupValues}
                            arrayCheckUncheck = {this.props?.userContext?.user_profile?.user_role_name ==="Read Only"
                                ? null
                                : this.arrayCheckUncheck
                            }
                            editData={this.editData}
                            sortCallback={this.handleTableColumnClick}
                            noResultsText={"No Selection"}
                        // highlightValue={this.state.renderList?.find(item => item.value === this.state.setIndex)?.label}
                        />
                    </MDBCol>
                </MDBRow>
                <MDBRow>
                    {this.state.showContent ?
                        <div>
                            <MDBRow>
                                <MDBCol md={12}>
                                    <div className="pt5">
                                        <MDBCol md={9} className="inline-block">
                                        {this.state.warningMessage && <span className="warning-text-color">This value already exists.</span>}
                                        {this.props?.userContext?.user_profile?.user_role_name !== "Read Only" &&
                                            <InlineButtonField
                                                id={"key21"}
                                                label={this.state.setIndex === 0 ? "Add Value" : "Edit Value"}
                                                value={this.state.inlineButtonField}
                                                placeholder={this.state.setIndex === 0 ? "Add Value" : "Edit Value"}
                                                onChange={(e) => this.setState({ inlineButtonField: e.target.value })}
                                                buttonOnClick={(e) => this.state.setIndex === 0 ? this.editList() : this.saveItem(this.state.setIndex, this.state.inlineButtonField)}
                                                totalTextFieldCount={1}
                                                editIcon={this.state.setIndex === 0 ? "" : "save"}
                                                limit={sizeLimits.nameCharacterLimit}
                                                limitWarning={messages.exceed50CharacterWarning || ""}
                                            />}
                                        </MDBCol>
                                        <MDBCol md={2} className="inline-block m-10">
                                        {(this.state.setIndex != 0 || this.state.warningMessage) && this.props?.userContext?.user_profile?.user_role_name !== "Read Only" ? 
                                            <BasicButton onClick ={() => this.setState({ setIndex: 0, inlineButtonField: "", warningMessage:false })}
                                                variant = "contained"
                                                size = "small"
                                                color = "primary"
                                                text = "Cancel"
                                                />: null
                                        }
                                        </MDBCol>
                                    </div>
                                </MDBCol>
                            </MDBRow>
                        </div>
                        : null}
                </MDBRow>
            </MDBContainer>
        )
    }
}

export default withUserContext(LookupValues);